export default "__VITE_ASSET__CPx$3d9v__"